const MODULE_ICON_FALLBACK = 'appstore-outlined'
const MENU_ICON_FALLBACK = 'menu-outlined'
const GOODS_ORDER_SCENE_DEFAULT = 'SERVICE'
const GOODS_ORDER_SCENE_BY_PATH = {
	'/biz/booking-workbench': 'SERVICE',
	'/biz/order-center': 'PRODUCT'
}
const GOODS_ORDER_SCENE_ALLOWLIST = new Set(['SERVICE', 'PRODUCT'])

const MENU_ICON_OVERRIDES = {
	'/auth/channel': 'cluster-outlined',
	'/auth/userchannelrelation': 'team-outlined',
	'/biz/mrreview': 'message-outlined'
}

const getMenuPath = (menu) => {
	if (!menu) {
		return ''
	}
	return menu.path || menu.meta?.active || ''
}

const isMenuHidden = (menu) => menu?.meta?.hidden || menu?.meta?.visible === 0 || menu?.visible === 0

const normalizeSceneQueryTab = (query = {}) => {
	const rawTab = Array.isArray(query?.tab) ? query.tab[0] : query?.tab
	if (typeof rawTab !== 'string') {
		return ''
	}
	const nextTab = rawTab.trim().toUpperCase()
	return GOODS_ORDER_SCENE_ALLOWLIST.has(nextTab) ? nextTab : ''
}

export const resolveMenuIcon = (menu, level = 1) => {
	if (menu?.meta?.icon) {
		return menu.meta.icon
	}
	const path = getMenuPath(menu)
	if (path && MENU_ICON_OVERRIDES[path]) {
		return MENU_ICON_OVERRIDES[path]
	}
	return level === 0 ? MODULE_ICON_FALLBACK : MENU_ICON_FALLBACK
}

export const findFirstMenuPath = (menus = []) => {
	for (const menu of menus) {
		if (!menu || isMenuHidden(menu)) {
			continue
		}
		if (Array.isArray(menu.children) && menu.children.length > 0) {
			const firstChildPath = findFirstMenuPath(menu.children)
			if (firstChildPath) {
				return firstChildPath
			}
		}
		const path = getMenuPath(menu)
		if (path && menu?.meta?.type !== 'catalog') {
			return path
		}
	}
	return ''
}

export const resolveGoodsOrderScene = (path = '', query = {}) => {
	const explicitScene = normalizeSceneQueryTab(query)
	if (explicitScene) {
		return explicitScene
	}
	return GOODS_ORDER_SCENE_BY_PATH[path] || GOODS_ORDER_SCENE_DEFAULT
}

export const normalizeMenuTree = (menus = [], level = 0) => {
	return menus.map((menu) => {
		const nextMenu = {
			...menu,
			meta: {
				...(menu.meta || {})
			}
		}
		nextMenu.meta.icon = resolveMenuIcon(nextMenu, level)
		if (Array.isArray(menu.children) && menu.children.length > 0) {
			nextMenu.children = normalizeMenuTree(menu.children, level + 1)
		}
		return nextMenu
	})
}
